import { observer } from "mobx-react";
import * as React from "react";
import Localization from "../../core/Localization";
import Sys from "../../core/Sys";
import Button from "../../coreui/Button";
import Dialog from "../../coreui/Dialog";
import DialogActions from "../../coreui/DialogActions";
import DialogContent from "../../coreui/DialogContent";
import Icon from "../../coreui/Icon";
import Typography from "../../coreui/Typography";
import Grid from "../../mustangui/Grid";
import GridItem from "../../mustangui/GridItem";

interface UploadsInProgressDialogProps {
  open: boolean;
  message: string;
  onClose: () => void;
}

const UploadsInProgressDialog: React.FC<UploadsInProgressDialogProps> = ({
  open,
  message,
  onClose,
}) => {
  const componentId = `uploads-in-progress-dialog-${Sys.nextId}`;
  const messageId = `${componentId}-message`;
  const titleId = `${componentId}-title`;

  const handleOk = () => {
    onClose();
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    switch (event.key) {
      case "Enter":
        if (
          !("nodeName" in event.target) ||
          (event.target as HTMLElement).nodeName !== "BUTTON"
        ) {
          handleOk();
        }
        break;
      case "Escape":
        handleOk();
        break;
      default:
    }
  };

  return (
    <Dialog
      aria-describedby={messageId}
      aria-labelledby={titleId}
      fullScreen={false}
      id={componentId}
      maxWidth="sm"
      onClose={handleOk}
      onKeyDown={onKeyDown}
      open={open}
      role="alertdialog"
    >
      <DialogContent>
        <Grid grouping="Closely Related" xs={1}>
          <GridItem xl={1} lg={1} md={1} sm={1} xs={1}>
            <Typography id={titleId} sx={{ color: "danger.main" }} variant="h3">
              <Icon
                fixedWidth
                icon="far fa-octagon-exclamation"
                sx={{ display: "inline", marginRight: ".4em" }}
              />
              {Localization.getBuiltInMessage("uploadsInProgressTitle")}
            </Typography>
          </GridItem>
          <GridItem xl={1} lg={1} md={1} sm={1} xs={1}>
            <Typography id={messageId}>{message}</Typography>
          </GridItem>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          paddingBottom: "20px",
        }}
      >
        <Button onClick={handleOk}>
          {Localization.getBuiltInMessage("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(UploadsInProgressDialog);
